import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { H3 } from '@/components/Typography/Typography';
import { SaleMark } from '@/components/ui/SaleMark/SaleMark';

interface ContractSubtitleWithRewardProps {
  reward: string;
  className?: string;
}

const ContractSubtitleWithReward: FC<ContractSubtitleWithRewardProps> = ({
  reward,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <H3 weight="bold">{t('Extra Reward')}</H3>
      <SaleMark text={reward} />
    </div>
  );
};

export { ContractSubtitleWithReward };
